import { Check, Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { formatDateTime } from '@/lib/formatters';
import { resolveNotificationLink } from '@/lib/notification-link';
import type { Notification } from '@/types';
import { TYPE_ICONS } from '../_constants';

// Tarjeta de una notificación en la lista. Extraído de index.tsx por ENG-LOC-01.
export function NotificationCard({
  notif,
  onClick,
  onMarkRead,
  isMarkingRead,
}: {
  notif: Notification;
  onClick: () => void;
  onMarkRead: () => void;
  isMarkingRead: boolean;
}) {
  const Icon = TYPE_ICONS[notif.notification_type] ?? Info;
  const link = resolveNotificationLink(notif.resource_type, notif.resource_id);

  return (
    <div
      onClick={onClick}
      className={cn(
        'flex items-start gap-3 rounded-xl border border-border p-4 transition-shadow hover:shadow-sm',
        notif.is_read ? 'bg-card' : 'bg-primary/5',
        link && 'cursor-pointer hover:bg-accent/50',
      )}
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-muted">
        <Icon className="h-4.5 w-4.5 text-muted-foreground" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className={cn('text-sm text-card-foreground', !notif.is_read && 'font-semibold')}>
            {notif.title}
          </h3>
          {!notif.is_read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-primary" />}
        </div>
        <p className="mt-0.5 text-sm text-muted-foreground">{notif.body}</p>
        <div className="mt-1 flex items-center gap-2">
          <span className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px] text-muted-foreground">
            {notif.reference_code}
          </span>
          <span className="text-xs text-muted-foreground">{formatDateTime(notif.created_at)}</span>
        </div>
      </div>
      {!notif.is_read && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onMarkRead();
          }}
          disabled={isMarkingRead}
          className="shrink-0 rounded-md p-1.5 text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
          title="Marcar como leída"
        >
          <Check className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
